"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RevieveSkinDiagnosis = void 0;
var _analyticsData = require("@ori/analytics-data");
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _Loading = require("../Loading");
var _Restore = require("../Restore");
var _jsxRuntime = require("react/jsx-runtime");
const RevieveSkinDiagnosis = () => {
  const {
    novageSkincareConfiguration
  } = (0, _contexts.useNovageSkincareAdvisor)();
  const {
    close,
    continueToPdp,
    initConfig,
    onInit,
    open,
    reset,
    state
  } = (0, _hooks.useRevieve)({
    queryParam: _constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM,
    recommendationPageEnabled: novageSkincareConfiguration?.recommendationPageEnabled,
    partnerId: novageSkincareConfiguration?.partnerId,
    placement: _analyticsData.Placement.RevieveSkinDiagnosis
  });
  const onLoad = (0, _react.useCallback)(() => {
    (0, _utils.initRevieve)(initConfig, onInit);
  }, [initConfig, onInit]);
  (0, _hooks.useRevieveScript)({
    param: _constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM,
    onLoad
  });
  // istanbul ignore next @preserve -- Calling of onClick is tested in useOnHrefClick
  const onClick = (0, _react.useCallback)(() => {
    reset();
    open();
  }, [reset, open]);
  (0, _hooks.useOnHrefClick)({
    href: _constants.OPEN_SKIN_DIAGNOSIS_HREF_ATTRIBUTE,
    onClick
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {
      show: state === _constants.STATE_LOADING
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Restore.Restore, {
      show: state === _constants.STATE_RESTORED,
      onClose: close,
      onContinue: continueToPdp,
      onReset: reset
    })]
  });
};
exports.RevieveSkinDiagnosis = RevieveSkinDiagnosis;
